@if (embedded$()) {
  <sol-select-content [select]="select$()" [callback]="contentCallback" (focusin)="onFocusIn()" #embeddedContent />
} @else {
  <div
    class="sol-select"
    role="combobox"
    [attr.aria-expanded]="popoverVisible$()"
    aria-haspopup="listbox"
    [attr.aria-disabled]="disabled$() || null"
    [class.sol-select-transparent]="transparent$()"
    [class.sol-select-disabled]="disabled$()"
    [class.sol-select-loading]="loading$()"
    [class.sol-select-error]="hasError$()"
    (click)="onClick()"
    (focusin)="onFocusIn()"
    (keydown.arrowdown)="onArrowKeyDown(1, $event)"
    (keydown.arrowup)="onArrowKeyDown(-1, $event)"
    (keydown.enter)="onEnterKey($event)"
    (keydown.space)="onSpaceKey($event)"
    (keydown.escape)="onEscapeKey($event)"
    (keydown.home)="onEdgeKey('first', $event)"
    (keydown.end)="onEdgeKey('last', $event)"
    [attr.aria-controls]="listboxId$()"
    [attr.aria-activedescendant]="activeOptionId$()"
    data-shortcut-ignore=""
    tabindex="0"
    #container
  >
    <div class="sol-select-control">
      @if (hasSelection$()) {
        <sol-view [data]="selectedViewData$()"></sol-view>
      } @else {
        <div class="sol-select-placeholder">
          {{ placeholder$() | translate }}
        </div>
      }
    </div>
    <div class="sol-select-actions">
      <sol-icon class="sol-select-chevron" [name]="SolIcon.chevron_down" />
    </div>
  </div>
}
